import axios from 'axios';
import { API_URL, SERVER_URL } from '../../configs/env.config';

/**
 * Decrypt the request URL
 * @param request
 * @returns {Promise<*>}
 */
export const decryptRequestURL = async (request) => {
  try {
    const options = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    const response = await axios.get(`${SERVER_URL}/content/decrypt?request=${request}`, options);
    return response.data;
  } catch (err) {
    throw err;
  }
};

/**
 * Encrypt Text
 */
export const encryptText = async (text) => {
  try {
    const options = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    const response = await axios.post(`${SERVER_URL}/text/encrypt`, JSON.stringify({ text }), options);
    return response.data;
  } catch (err) {
    throw err;
  }
};

/**
 * Fetch API - [GET] get html detail
 * @param id
 * @returns {Promise<{idError: *}>}
 */
export const getHTMLDetail = async (id) => {
  try {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    };
    const response = await axios.get(`${API_URL}/content/${id}`, options);
    return response.data;
  } catch (err) {
    throw err;
  }
};

/**
 * Fetch API - [PUT] Upadte html detail
 */
export const updateHTMLDetail = async (payload) => {
  try {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    };
    const response = await axios.put(`${API_URL}/content/${payload.id}`, JSON.stringify(payload), options);
    return response.data;
  } catch (err) {
    throw err;
  }
};

/**
 * Fetch API - [GET] get html template
 */
export const getHTMLTemplate = async (templateURL) => {
  try {
    // return temp;
    const response = await axios.get(templateURL);
    return response.data;
  } catch (err) {
    throw err;
  }
};

/**
 * Upload image
 */
export const uploadImage = async (image) => {
  try {
    const options = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    };
    const formData = new FormData();
    formData.append('file', image, image.filename);
    const response = await axios.post(`${API_URL}/util/upload`, formData, options);
    return response.data;
  } catch (err) {
    throw err;
  }
};



// WEBPACK FOOTER //
// ./src/containers/html/api.js